import site from '../content/site.json';
import { getRuntimeSite } from './content-runtime';

export type SiteContent = typeof site;

export function getSite(): SiteContent {
  return getRuntimeSite() as SiteContent;
}
